import React from 'react';
import { Route } from 'react-router-dom';
import { Routes } from 'react-router-dom';
import Home from './Home';


function App() {
  return (
    <div>
      <Routes>
        <Route exact path='/' element={<Home/>}></Route>
        {/* <Route path='/Authunom'element={<Authunom/>}></Route> */}
      </Routes>
    </div>
  );
}

export default App;
